import React from 'react';
import SelectIndex from '../../form/select/index';
import getData from './data';

class Province extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    componentWillMount(){
        getData(({country={}, province={}, city = {}, district={}})=>{
            let parent_node = this.props.parent_node;
            this.setState({
                options: parent_node ? province.options : []
            });
            parent_node && (parent_node.options = country.options);
        });
    }
    render(){
        let  options= this.state.options || [];
        return (
            <SelectIndex {...this.props} options = {options}/>
        )
    }
    
}

export default Province;


// WEBPACK FOOTER //
// ./src/component/AddressOld/Province.js